import { useState } from 'react';
import { renderToolTip } from '../../../utils/helper';

export const headerFormatter = (column, colIndex, { sortElement, filterElement }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {renderToolTip(column?.toolTipText, column?.text)}
      {sortElement}
    </div>
  );
};

export const calculatePercentageOfTotal = (count, total) => {
  if (count > 0 && total > 0) return `${count}(${((count / total) * 100).toFixed(2)})`;
  else if (count) return count;
  else return 0;
};

export const NameCellFormatter = ({ row, redirectToDetailPage }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      {row?.name ? (
        <>
          <span style={{ cursor: 'pointer' }}>{row.name}</span>
          {hovered && (
            <div
              style={{
                color: '#3e59e3',
                position: 'absolute',
                top: '100%',
                left: '0',
                backgroundColor: 'white',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '5px',
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
              }}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-bar-chart-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z" />
                </svg>
              </span>
              <span
                style={{ whiteSpace: 'nowrap' }}
                onClick={() => {
                  redirectToDetailPage(row);
                }}
              >
                View insights
              </span>
            </div>
          )}
        </>
      ) : (
        '-'
      )}
    </div>
  );
};

export const LanguageList = [
  {
    value: 'hi',
    label: 'Hindi',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'en_US',
    label: 'English (US)',
  },
  {
    value: 'en_GB',
    label: 'English (UK)',
  },
  {
    value: 'bn',
    label: 'Bengali',
  },
  {
    value: 'gu',
    label: 'Gujarati',
  },
  {
    value: 'ml',
    label: 'Malayalam',
  },
  {
    value: 'mr',
    label: 'Marathi',
  },
  {
    value: 'pa',
    label: 'Punjabi',
  },
  {
    value: 'ta',
    label: 'Tamil',
  },
  {
    value: 'te',
    label: 'Telugu',
  },
];

export const CategoryOptions = [
  {
    label: 'Marketing',
    value: 'MARKETING',
  },
  {
    label: 'Utility',
    value: 'UTILITY',
  },
  {
    label: 'Authentication',
    value: 'AUTHENTICATION',
  },
];

export const HeaderOptions = [
  { label: 'Text', value: 'TEXT' },
  { label: 'Image', value: 'IMAGE' },
  { label: 'Video', value: 'VIDEO' },
  { label: 'Document', value: 'DOCUMENT' },
];

export const WHATSAPP_ALLOWED_MIME = {
  image: ['image/jpeg', 'image/png'],
  video: ['video/mp4', 'video/3gpp'],
  audio: [
    'audio/aac',
    'audio/mp4',
    'audio/mpeg',
    'audio/mp3',
    'audio/amr',
    'audio/ogg',
    'audio/webm',
    'audio/wav',
    'audio/x-wav',
    'audio/opus',
  ],
  file: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'text/csv',
  ],
};

export const WHATSAPP_LIMITS = {
  image: 5 * 1024 * 1024, // 5 MB
  video: 16 * 1024 * 1024, // 16 MB
  audio: 16 * 1024 * 1024, // 16 MB
  file: 100 * 1000 * 1000, // 100 MB (documents, decimal)
};

export const BLOCKED_EXTENSIONS = new Set([
  '.exe', '.msi', '.cmd', '.bat', '.com', '.scr', '.dll',
  '.sh', '.bash', '.ksh', '.zsh', '.ps1', '.psm1',
  '.vbs', '.js', '.mjs', '.ts', '.tsx', '.jsx',
  '.py', '.pyc', '.pyo', '.rb', '.php', '.pl', '.jar',
  '.apk', '.ipa', '.reg', '.sql',
]);
